import { _first, _last } from '@dinosband/dbi-utils'

interface DbObject {
  id: number
}

export function isOverlapped<T extends DbObject> (list1: T[], list2: T[]) {
  const first1 = _first(list1)?.id
  const last1 = _last(list1)?.id
  const first2 = _first(list2)?.id
  const last2 = _last(list2)?.id
  if (!first1 || !last1 || !first2 || !last2) {
    return false
  }
  return first1 <= last2 && first2 <= last1
}

export function merge<T extends DbObject> (list1: T[], list2: T[], continuous = true) {
  const first1 = _first(list1)?.id
  const last1 = _last(list1)?.id
  const first2 = _first(list2)?.id
  const last2 = _last(list2)?.id
  if (first1 === first2 && last1 === last2) {
    return list1
  }
  if (!first1 || !last1 || !first2 || !last2) {
    return [...list1, ...list2]
  }
  if (last1 < first2) {
    return continuous ? [...list1, ...list2] : list2
  }
  if (last2 < first1) {
    return continuous ? [...list2, ...list1] : list2
  }
  if (first2 <= first1 && last1 <= last2) {
    return list2
  }
  if (first1 <= first2 && last2 <= last1) {
    return list1
  }
  if (first2 < first1) {
    // overlapped list2 < list1
    const valid = list1.filter((i) => last2 < i.id)
    return [...list2, ...valid]
  }
  // overlapped list1 < list2
  const valid = list1.filter((i) => i.id < first2)
  return [...valid, ...list2]
}
